import WebDevelopment from '../../images/services/web-development.png'
import WebDesignb from '../../images/services/web-design.png'
import Andorid from '../../images/services/android.png'
import UX from '../../images/services/ux.png'


const ServiceData = [
    {
        icon: WebDesignb,
        name: "Web Designing ",
        description: "Having a unique website design is important part of the branding and marketing process of your business.",
        delay:"0.2s"
    },
    {
        icon: WebDevelopment,
        name: "Web Development",
        description: "We professionally design, redesign and continuously support customer-facing and enterprise web apps to achieve high conversion and adoption rates",
        delay:"0.4s"
    }, 
    // {
    //     icon: WhatsApp,
    //     name: "Digital Branding ",
    //     description: "Our new-fangled approach to advertising is directed creating and building deep love for your brand",
    //     delay:"0.6s"
    // },
    {
        icon: Andorid,
        name: "Mobile App Development ",
        description: "Our specialized development teams Experience A World-Class Mobile App Development Service Build Affordable, Easy-to-use & Feature-Rich Mobile Apps For Your Business.",
        delay:"0.6s"
    }, 
    {
        icon: UX,
        name: "UI/UX and Games ",
        description: "If you are looking for expert game developers and UI/UX Designing in the town, then your search ends with us.",
        delay:"0.8s"
    }, 
    

]

export default ServiceData;